import { useSharedTimeCapsules } from "api/ApiHooks"
import { useParams } from "react-router-dom"
import { TimeCapsuleListItem } from "./TimeCapsuleListItem"

export const SharedTimeCapsuleList = ({ onClick }: { onClick?: () => void }) => {
  const sharedTimeCapsulesQuery = useSharedTimeCapsules()
  const { slug } = useParams()

  if (
    sharedTimeCapsulesQuery.isLoading ||
    !sharedTimeCapsulesQuery.data ||
    sharedTimeCapsulesQuery.data.timeCapsules.length < 1
  )
    return null

  return (
    <>
      <div className="text-xs/6 font-semibold text-gray-400">Shared With Me</div>
      <ul role="list" className="-mx-2 mt-2 space-y-2">
        {sharedTimeCapsulesQuery.data?.timeCapsules.map((capsule) => (
          <TimeCapsuleListItem
            id={capsule.id}
            slug={`shared/${capsule.creatorId}/${capsule.slug}`}
            name={capsule.name}
            subtitle={`by ${capsule.creatorName}`}
            opensAt={capsule.opensAt}
            isSelected={slug === capsule.slug}
            onClick={onClick}
          />
        ))}
      </ul>
    </>
  )
}
